const columns = [
    {
        title: 'Name',
        dataIndex: 'name',
    },
    {
        title: 'Email',
        dataIndex: 'email',
        // sorter: true
    },
    {
        title: 'Mobile No.',
        dataIndex: 'phoneNo',
    },
    {
        title: 'Request Date',
        dataIndex: 'createdDate',
        // sorter: true
    },
    {
        title: 'Approve Date',
        dataIndex: 'actionDate',
        // sorter: true
    },
    {
        title: 'Action By',
        dataIndex: 'actionBy',
    },
    {
        title: 'Action',
        dataIndex: 'action'
    }
];

export default columns;